import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "298.88 215.5 83.92 71.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M338.2 249 305 227.7v42.6c0 .3.1.7.4.9.2.2.6.4.9.4h34.1c0 1.1.1 2.1.2 3.2.1 1 .4 2.1.7 3.1h-34.9c-2 0-3.9-.8-5.3-2.2s-2.2-3.3-2.2-5.3V223c0-2 .8-3.9 2.2-5.3s3.3-2.2 5.3-2.2h64c2 0 3.9.8 5.3 2.2s2.2 3.3 2.2 5.3v23.8c-1-.5-1.9-.8-3-1.1s-2.2-.5-3.3-.7v-17.2zm0-6.5 32.6-20.8h-65.3zM305 271.6",
  style: {"fill":"#989ea9"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M355.2 270.7H373V266h-17.8zm8.9 16.3c-2.5 0-5-.5-7.3-1.5-2.2-.9-4.2-2.3-5.9-4s-3-3.7-4-5.9c-1-2.3-1.5-4.8-1.5-7.3s.5-5 1.5-7.3c.9-2.2 2.3-4.2 4-5.9s3.7-3 5.9-4c2.3-1 4.8-1.5 7.3-1.5s5 .5 7.3 1.5c2.2.9 4.2 2.3 5.9 4s3 3.7 4 5.9c1 2.3 1.5 4.8 1.5 7.3s-.5 5-1.5 7.3c-.9 2.2-2.3 4.2-4 5.9s-3.7 3-5.9 4c-2.3 1-4.8 1.5-7.3 1.5",
  style: {"fill":"#989ea9"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }